<header-title [model]="headerTitle"></header-title>
    <section class="admin-panel">

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-building"></i>
                </div>
                <h3>Companies</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/company']"><i class="fas fa-building"></i> Existing Companies</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/company']"><i class="fas fa-plus"></i> Add New Company</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-user"></i>
                </div>
                <h3>Users</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/account/users']"><i class="fas fa-user"></i> Existing Users</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/account/users']"><i class="fas fa-plus"></i> Add new User</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-tasks"></i>
                </div>
                <h3>Audit Templates</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/audit-template']"><i class="fas fa-tasks"></i> Audit Templates</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/audit/audittype']"><i class="fas fa-plus"></i> Audit Types</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-cubes"></i>
                </div>
                <h3>Modules</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/module']"><i class="fas fa-cubes"></i> Modules</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/module']"><i class="fas fa-plus"></i> Add Modules</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-question"></i>
                </div>
                <h3>Questions</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/question']"><i class="fas fa-question"></i> Questions</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/question/questionbank']"><i class="fas fa-plus"></i> Question Bank</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-dollar-sign"></i>
                </div>
                <h3>Lenders</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/lenders']"><i class="fas fa-dollar-sign"></i> Lenders</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/lenders']"><i class="fas fa-plus"></i> Lenders</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="card mt-4">
            <header class="card-header text-gray-600">
                <div class="card-header-icon">
                    <i class="fas fa-user-tie"></i>
                </div>
                <h3>Brokers</h3>
            </header>
            <div class="card-body">
                <ul>
                    <li>
                        <a class="nav-link" [routerLink]="['/brokers']"><i class="fas fa-user-tie"></i> Brokers</a>
                    </li>
                    <li>
                        <a class="nav-link" [routerLink]="['/brokers']"><i class="fas fa-plus"></i> Brokers</a>
                    </li>
                </ul>
            </div>
        </section>
</section>
